import React, { useCallback, useEffect, useRef, useState, FC } from "react";

import { DeviceEventEmitter, FlatList, Pressable, RefreshControl, ScrollView, TouchableOpacity, useWindowDimensions, View } from "react-native";
import { ThemeConsumer } from '@rneui/themed'
import { getScreenPermission, useAppDispatch, useAppSelector } from "../../redux/hooks";
import { changeStatus, deleteStaff, getAllStaffList, LocationWithSelected, STAFF_LIST_LIMIT, User } from "../../redux/slices/staffSlice";
import { ZenBadge, ZenDivider, ZenEmptyComponent, ZenFilterModal, ZenIcon, ZenLoader, ZenToast, ZenText } from "zen-core-elements";
import CommonDialogBox from "../../shared/commonComponents/commonDialogBox";
import { useAppNavigation, useAppRoute } from "../../types/@react-navigation/navigation";
import Popover from "react-native-popover-view";
import { getAllRoles } from "../../redux/slices/rolesSlice";
import { config } from "../../shared/environment";
import { filterItemsProps } from "zen-core-elements"
import TargetHistory from "./targetHistory";
import { useIsFocused } from "@react-navigation/native";
import { ListToolbar } from "../../shared/commonComponents/listToolbar";
import { LocationProps } from "../settings/location/locationModule";
import { shallowEqual } from "react-redux";

let limit = 10
interface staffProps {
    isActive: boolean
}

const StaffList: FC<staffProps> = (props) => {
    const isFocused = useIsFocused()
    const { isWrite: isStaffWrite } = useAppSelector(getScreenPermission("StaffStack"), shallowEqual)
    const staffRolesData = useAppSelector((state) => state?.roles?.value?.roles?.rows)?.map(item => ({
        ...item,
        value: item.id,
        label: item.name
    }))

    const staffListData = useAppSelector((state) => state?.staff?.staffList)
    const locationData = useAppSelector(state => state?.common?.getStoreLocations?.value)
    const [isLoading, setIsLoading] = useState(!staffListData?.ActiveStaffList.value || !staffListData?.InActiveStaffList.value)
    //Variable to store useRoute value
    const route = useAppRoute("staffList")
    //Variable to store current screen name
    const [screenName, setscreenName] = useState<"InActiveStaffList" | "ActiveStaffList" | null>(null)
    const { width, height } = useWindowDimensions()

    //State variable to use useAppDispatch hook
    const dispatch = useAppDispatch()

    const userDetails = useAppSelector((state) => state?.common?.currentUser?.value)

    const navigation = useAppNavigation()

    const [staffStatus, setStaffStatus] = useState<boolean>(true)

    const [statusPop, setStatusPop] = useState(false)

    const [selectedId, setSelectedId] = useState<string | null>(null)

    //State variable to store boolean value for refresh functionality
    const [isRefresh, setIsRefresh] = useState<boolean>(false)

    //State variable to store offset value for list  <- REMOVED old offset comment to avoid confusion, repurposing or removing
    //Using a new state for LOCAL pagination
    const [visibleCount, setVisibleCount] = useState<number>(10);
    const API_LIMIT = STAFF_LIST_LIMIT;

    const statusDialogProps2 = {
        content: staffStatus ? 'Are you sure you want to InActive this staff' : 'Are you sure you want to Active this staff',
        button: [{ id: 2, name: "yes" }, { id: 1, name: 'no' }],
    }

    const [deletePopoverVisible, setDeletePopoverVisible] = useState(false)

    const [footLoader, setFootLoader] = useState(false)

    // ... (keep existing filter states)
    const [staffFilter, setStaffFilter] = useState<filterItemsProps[]>([
        {
            id: '1',
            filterName: 'Role',
            filterType: "radio",
            filterValue: [
                {
                    value: 'POS',
                    label: 'POS',
                },
            ],
            initialSelected: '',
        },
    ])

    const [staffFilterOpen, setStaffFilterOpen] = useState(false)

    const [filterCount, setFilterCount] = useState(0)

    const [filterPayLoad, setFilterPayLoad] = useState<{ values: { [key: string]: any }, filterCount: number } | null>(null)

    const [searchValue, setSearchValue] = useState<string | null>(null)


    const { id: locationId } = useAppSelector((state) => state?.common?.currentLocation)

    const [target, setTarget] = useState<{ visible: boolean, selectedId: number | null, name: string }>({ visible: false, selectedId: null, name: '' })

    const onMomentumScrollBegin = useRef(false);

    // Filter Logic
    const getFilteredData = useCallback(() => {
        let data = staffListData[screenName!]?.value || [];

        // 1. Search Filter (Name/Email)
        if (searchValue) {
            const lowerSearch = searchValue.toLowerCase();
            data = data.filter(item =>
                (item.firstName && item.firstName.toLowerCase().includes(lowerSearch)) ||
                (item.email && item.email.toLowerCase().includes(lowerSearch))
            );
        }

        // 2. Location Filter
        if (locationId !== 1) { // Assuming id 1 is 'All Location'
            data = data.filter(item =>
                item.userLocationsMappings?.some(loc => loc.locationId === locationId)
            );
        }

        // 3. Role Filter
        if (filterPayLoad?.values?.Role) {
            data = data.filter(item => String(item.role?.role_id) === String(filterPayLoad.values.Role));
        }

        return data;
    }, [staffListData, screenName, searchValue, locationId, filterPayLoad]);

    const filteredStaffData = getFilteredData();
    const visibleData = filteredStaffData.slice(0, visibleCount);
    console.log(JSON.stringify(visibleData, undefined, 4), visibleCount, "============");


    useEffect(() => {
        const staffUpdate = DeviceEventEmitter.addListener("STAFF_UPDATED", () => {
            setFilterPayLoad(null)
            DeviceEventEmitter?.emit(props?.isActive ? "Active Staff" : "Inactive Staff")
            setSearchValue(null)
            setVisibleCount(10)
            setSelectedId(null);
        })
        return () => {
            staffUpdate?.remove()
        }
    }, [])

    useEffect(() => {
        if (!isFocused) return;
        setSelectedId(null);
        setFilterPayLoad(null);
        setVisibleCount(10);
        getStaffAndRoles();
    }, [isFocused]);

    const confirmation = ({ id, name }: { id: number, name: string }) => {
        if (id == 2) {
            let staffStatus = !props.isActive
            if (deletePopoverVisible) {
                setDeletePopoverVisible(false)
                setIsLoading(true)
                deleteStaffUpdation(selectedId ?? '')
            }
            else {
                setDeletePopoverVisible(false)
                setIsLoading(true)
                changeStaffStatus(selectedId ?? '', staffStatus)
            }
        } else {
            deletePopoverVisible ? setDeletePopoverVisible(false) : setStatusPop(false)
        }
    }


    useEffect(() => {
        if (isFocused && !screenName) {
            setscreenName(route?.name as "InActiveStaffList" | "ActiveStaffList")
            setStaffStatus(props?.isActive);
        }
    }, [isFocused, screenName])

    // Initial Fetch Effect - Only on screen name or first load, NOT on offset/search/filters
    useEffect(() => {
        if (screenName) {
            // if (shouldSkipFetch.current) {
            //     shouldSkipFetch.current = false;
            //     return;
            // }
            getAllStaff()
        }
    }, [screenName])


    useEffect(() => {
        // Reset pagination when filters change
        setVisibleCount(10);
    }, [searchValue, filterPayLoad])

    const getStaffAndRoles = async () => {
        try {
            await getRoles()
        } catch (err) {
            ZenToast({ type: 'error', message: 'Something went Wrong try again later' })
            console.error('Error:', err);
        }
    }

    const getAllStaff = async () => {
        try {
            // Fetch everything - No filters passed to API
            await dispatch(getAllStaffList({
                storeId: config.storeId,
                roleId: userDetails?.clientId || '', isActive: staffStatus, data: {
                    limit: API_LIMIT,
                    offset: 0,
                    filterData: null,
                    searchText: '',
                }
            })).unwrap().catch((err) => {
                ZenToast({ type: 'error', message: 'Something went Wrong try again later' })
                console.log("error in getAllStaffList-->", err);
            }).finally(() => {
                setIsLoading(false)
                setFootLoader(false)
                setIsRefresh(false)
            })
        }
        catch (error) {
            console.log("error in getAllStaff--> ", error);
        }
    }

    const getRoles = async () => {
        try {
            if (staffRolesData && staffRolesData.length > 0) {
                let allRoles = [...staffRolesData]

                allRoles = allRoles.map((item: any) => {
                    return {
                        ...item,
                        label: item.name,
                        value: String(item.id)
                    }
                })
                setStaffFilter((prev) => {
                    return prev?.map((item: any) => ({
                        ...item,
                        filterValue: allRoles
                    }));
                });
                return;
            }
            dispatch(getAllRoles({ storeId: config.storeId })).unwrap().then(async (res) => {
                let allRoles = [...res?.roles?.rows]
                allRoles = allRoles.map((item) => {
                    return {
                        ...item,
                        label: item.name,
                        value: String(item.id)
                    }
                })
                setStaffFilter((prev) => {
                    return prev?.map((item: any) => ({
                        ...item,
                        filterValue: allRoles
                    }));
                });
            }).catch(() => {

            })
        }
        catch (error) {
            console.log("error in getRolesfunc-->", error);
        }
    }

    const changeStaffStatus = async (id: string, flag: boolean) => {
        try {
            dispatch(changeStatus({ staffId: id, data: { isActive: flag }, storeId: config.storeId })).unwrap()
                .catch((error) => {
                    console.log("error in changeStatus", error);
                }).finally(() => {
                    setSelectedId(null)
                    setStatusPop(false)
                    setTimeout(() => {
                        setIsLoading(false)
                    }, 2000);
                })
        }
        catch (error) {
            console.log("error in the changeStaffStatus", error);
        }
    }

    const deleteStaffUpdation = async (id: string) => {
        try {
            await dispatch(deleteStaff({ staffId: id, data: { isDeleted: true }, storeId: config.storeId })).unwrap()
                .catch((error) => {
                    console.log("error in the deleteStaff", error);
                }).finally(() => {
                    setTimeout(() => {
                        setIsLoading(false)
                    }, 2000);
                })
        }
        catch (error) {
            console.log("error in the deleteStaff", error);
        }
    }

    const closeTargetPopover = () => {
        setTarget({ selectedId: 0, visible: false, name: '' })
    }

    const RenderItem = ({ item, index }: { item: User, index: number }) => {
        return (
            <ThemeConsumer>
                {({ theme }) => {
                    const isLandscapeMode = width > height;
                    return (
                        <TouchableOpacity activeOpacity={1} style={theme?.staffListStyle?.renderItemContainer}>
                            <View style={theme?.staffListStyle?.renderItemHeader}>
                                <View style={theme?.staffListStyle?.renderItemName}>
                                    <ZenText content={item?.firstName} color={theme?.lightDark} size={theme?.mediumFontSize} bold style={{ marginVertical: 10 }} ellipsizeMode="tail" numberOfLines={1} />
                                    <ZenBadge
                                        badgeColor={"#DCFCE7"}
                                        badgeName={item?.role?.role}
                                        badgeTextColor={"#15803D"}
                                        badgeContainerStyle={{ top: 10 }}
                                        badgeTextSize={isLandscapeMode ? 'medium' : 'small'}
                                    />
                                </View>
                            </View>

                            <ZenDivider style={theme?.staffListStyle?.dividerStyle} />

                            <View style={theme?.staffListStyle?.renderItemDetails}>
                                {isLandscapeMode ? (
                                    <>
                                        <View style={theme?.staffListStyle?.emailContainer}>
                                            <ZenText content="Email" size={theme?.smallFontSize} color={theme?.labelColor} style={{ paddingVertical: 1 }} />
                                            <ZenText content={item?.email} size={theme?.smallFontSize} color={theme?.lightDark} bold style={{ paddingVertical: 1 }} />
                                        </View>
                                        <View style={theme?.staffListStyle?.phoneContainer}>
                                            <ZenText content="Phone" size={theme?.smallFontSize} color={theme?.labelColor} style={{ paddingVertical: 1 }} />
                                            <ZenText content={item?.phone} size={theme?.smallFontSize} color={theme?.lightDark} bold style={{ paddingVertical: 1 }} />
                                        </View>

                                        <View style={theme?.staffListStyle?.roleContainer}>
                                            <ZenText content="Role" size={theme?.smallFontSize} color={theme?.labelColor} style={{ paddingVertical: 1 }} />
                                            <ZenText content={item?.role?.role} size={theme?.smallFontSize} color={theme?.lightDark} bold style={{ paddingVertical: 1 }} />
                                        </View>

                                        <View style={theme?.staffListStyle?.itemActionContainer}>
                                            <TouchableOpacity onPress={() => {
                                                navigation.navigate('AddEditStaff', { id: item?.userId, isEdit: true, isActive: props?.isActive })
                                            }} style={theme?.staffListStyle?.actionButtonEdit} >
                                                <ZenIcon name={isStaffWrite ? "pencil" : "eye"} type="octicon" size={theme?.iconSize} color={theme?.primary} />
                                            </TouchableOpacity>

                                            <TouchableOpacity onPress={() => navigation.navigate('StaffLoginHistory', { staffId: item?.id })} style={theme?.staffListStyle?.actionButtonHistory} >
                                                <ZenIcon name="history" type="material-community" size={theme?.iconSize} color="#0ca85a" />
                                            </TouchableOpacity>

                                            {isStaffWrite && <TouchableOpacity onPress={() => {
                                                setSelectedId(item?.userId)
                                                setStatusPop(true)
                                            }} style={theme?.staffListStyle?.actionButtonStatus} >
                                                <ZenIcon name="close-circle-outline" type="material-community" size={theme?.iconSize} color={theme?.secondary} />
                                            </TouchableOpacity>}

                                            <TouchableOpacity onPress={() => {
                                                setTarget({ visible: true, selectedId: item?.id, name: item?.firstName })
                                            }} style={theme?.staffListStyle?.actionButtonTarget} >
                                                <ZenIcon name="target" type="material-community" size={theme?.iconSize} color="#ad639e" />
                                            </TouchableOpacity>

                                            {isStaffWrite && <TouchableOpacity onPress={() => {
                                                setSelectedId(item?.userId)
                                                setDeletePopoverVisible(true)
                                            }} style={theme?.staffListStyle?.actionButtonDelete} >
                                                <ZenIcon name="delete-outline" type="material-community" size={theme?.iconSize} color={theme?.red} />
                                            </TouchableOpacity>}
                                        </View>
                                    </>
                                ) : (
                                    <View style={{ gap: 10, flex: 1 }}>
                                        <View style={theme?.staffListStyle?.detailRow}>
                                            <ZenText content="Email" size={theme?.smallFontSize} color={theme?.labelColor} style={{ width: 60 }} />
                                            <ZenText content={item?.email} size={theme?.smallFontSize} color={theme?.lightDark} bold style={{ flex: 1 }} />
                                        </View>
                                        <View style={theme?.staffListStyle?.detailRow}>
                                            <ZenText content="Phone" size={theme?.smallFontSize} color={theme?.labelColor} style={{ width: 60 }} />
                                            <ZenText content={item?.phone} size={theme?.smallFontSize} color={theme?.lightDark} bold style={{ flex: 1 }} />
                                        </View>
                                        <View style={theme?.staffListStyle?.detailRow}>
                                            <ZenText content="Role" size={theme?.smallFontSize} color={theme?.labelColor} style={{ width: 60 }} />
                                            <ZenText content={item?.role?.role} size={theme?.smallFontSize} color={theme?.lightDark} bold style={{ flex: 1 }} />
                                        </View>
                                    </View>
                                )}
                            </View>

                            {!isLandscapeMode && (
                                <View style={theme?.staffListStyle?.itemActionContainerPortrait}>
                                    <TouchableOpacity onPress={() => {
                                        navigation.navigate('AddEditStaff', { id: item?.userId, isEdit: true, isActive: props?.isActive })
                                    }} style={theme?.staffListStyle?.actionButtonEdit} >
                                        <ZenIcon name={isStaffWrite ? "pencil" : "eye"} type="octicon" size={theme?.iconSize} color={theme?.primary} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => navigation.navigate('StaffLoginHistory', { staffId: item?.id })} style={theme?.staffListStyle?.actionButtonHistory} >
                                        <ZenIcon name="history" type="material-community" size={theme?.iconSize} color="#0ca85a" />
                                    </TouchableOpacity>

                                    {isStaffWrite && <TouchableOpacity onPress={() => {
                                        setSelectedId(item?.userId)
                                        setStatusPop(true)
                                    }} style={theme?.staffListStyle?.actionButtonStatus} >
                                        <ZenIcon name="close-circle-outline" type="material-community" size={theme?.iconSize} color={theme?.secondary} />
                                    </TouchableOpacity>}

                                    <TouchableOpacity onPress={() => {
                                        setTarget({ visible: true, selectedId: item?.id, name: item?.firstName })
                                    }} style={theme?.staffListStyle?.actionButtonTarget} >
                                        <ZenIcon name="target" type="material-community" size={theme?.iconSize} color="#ad639e" />
                                    </TouchableOpacity>

                                    {isStaffWrite && <TouchableOpacity onPress={() => {
                                        setSelectedId(item?.userId)
                                        setDeletePopoverVisible(true)
                                    }} style={theme?.staffListStyle?.actionButtonDelete} >
                                        <ZenIcon name="delete-outline" type="material-community" size={theme?.iconSize} color={theme?.red} />
                                    </TouchableOpacity>}
                                </View>
                            )}
                        </TouchableOpacity>
                    );
                }}
            </ThemeConsumer>
        )
    }

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <View style={[theme?.staffListStyle?.pageContainer]}>
                    <ListToolbar
                        search={{
                            value: searchValue,
                            onChange: (val) => setSearchValue(val as string),
                            onCancel: () => setSearchValue(null),
                            placeholder: 'Search name, email',
                        }}
                        filter={{
                            count: filterPayLoad?.filterCount ?? 0,
                            onPress: () => setStaffFilterOpen(true),
                        }}
                        buttons={isStaffWrite ? [
                            {
                                title: "Add Staff",
                                onPress: () => navigation.navigate('AddEditStaff', { id: '', isEdit: false, isActive: props?.isActive })
                            }
                        ] : []}
                    />

                    {
                        isLoading ? <ZenLoader lottieType="Local" lottie={require('../../assets/infinityLoader.json')} /> :
                            <View style={theme?.staffListStyle?.listContainer}>
                                <FlatList
                                    data={visibleData}
                                    renderItem={RenderItem}
                                    numColumns={1}
                                    scrollEnabled
                                    keyExtractor={(_: any, index: number) => index?.toString()}
                                    ListFooterComponentStyle={{ height: visibleData.length ? 20 : 0 }}
                                    showsVerticalScrollIndicator={false}
                                    onMomentumScrollBegin={() => {
                                        onMomentumScrollBegin.current = true;
                                    }}
                                    onEndReached={() => {
                                        if (!onMomentumScrollBegin.current) return;
                                        if (footLoader) return;
                                        if (filteredStaffData.length > visibleCount) {
                                            setFootLoader(true);
                                            // Simulate network delay or just update state immediately
                                            setTimeout(() => {
                                                setVisibleCount(prev => prev + 10);
                                                setFootLoader(false);
                                            }, 500);
                                        }
                                    }}
                                    refreshControl={<RefreshControl refreshing={isRefresh} onRefresh={() => {
                                        setIsRefresh(true)
                                        setVisibleCount(10)
                                        setSearchValue(null)
                                        DeviceEventEmitter.emit(props?.isActive ? "Active Staff" : "Inactive Staff")
                                        setFilterPayLoad(null)
                                        getAllStaff(); // Re-fetch from API
                                    }} />}
                                    contentContainerStyle={{
                                        paddingBottom: visibleData.length ? 10 : undefined,
                                        flexGrow: visibleData.length ? undefined : 1,
                                        // gap: visibleData.length ? 10 : 0,
                                    }}
                                    ListEmptyComponent={<ZenEmptyComponent />}
                                    onEndReachedThreshold={0.01}
                                    ListFooterComponent={footLoader ? <View style={theme?.staffListStyle?.listFooter}>
                                        <ZenLoader size={"small"} color={theme?.primary} />
                                    </View> : <></>}
                                />
                            </View>
                    }
                    {
                        width < height && isStaffWrite &&
                        <Pressable
                            style={theme?.staffListStyle?.fabButton}
                            onPress={() => { navigation.navigate('AddEditStaff', { id: '', isEdit: false, isActive: props?.isActive }) }}>
                            <ZenIcon type="material-community" name={"plus"} size={25} color={theme?.light} />
                        </Pressable>
                    }

                    <Popover isVisible={statusPop || deletePopoverVisible} popoverStyle={[{ width: width > height ? width / 2 : width - 50 }, theme?.staffListStyle?.popoverStyle]}>
                        {deletePopoverVisible ? <CommonDialogBox type={'DELETE'} replaceValue="staff" confirmation={confirmation} />
                            : <CommonDialogBox
                                dialog={statusDialogProps2}
                                type='OTHER'
                                confirmation={confirmation}
                            />
                        }
                    </Popover>

                    <ZenFilterModal
                        title=""
                        filterName={props?.isActive ? "Active Staff" : "Inactive Staff"}
                        setVisible={setStaffFilterOpen}
                        filterCount={filterCount}
                        setFilterCount={setFilterCount}
                        visible={staffFilterOpen}
                        filterItems={staffFilter}
                        setFilterItems={setStaffFilter}
                        onConfirm={(val) => {
                            setFilterPayLoad(val)
                        }}
                    />

                    <Popover isVisible={target.visible} popoverStyle={[{ width: width > height ? width / 2 : width - 100 }, theme?.staffListStyle?.popoverStyle]} onRequestClose={closeTargetPopover}>
                        <TargetHistory staffId={target.selectedId ?? 0} onClose={closeTargetPopover} staffName={target.name} />
                    </Popover>
                </View>
            )}
        </ThemeConsumer>
    )
}

export default StaffList



